import { TRootState } from '../reducers';
import { ISolutionsState } from '../reducers/types';

export const selectSolutions = (state: TRootState): ISolutionsState['solutions'] => {
  return state.solutions.solutions;
};

export const selectSolutionsIsLoading = (state: TRootState): ISolutionsState['isLoading'] => {
  return state.solutions.isLoading;
};
